import axiosClient from './axiosClient';

const NotificationService = {
    // Shared
    getNotifications: async (role, params) => {
        // role: 'admin' or 'vendors' (note the plural for vendors in the guide)
        // params: { page: 1, limit: 20 }
        const endpoint = role === 'vendor' ? '/vendors/notifications' : '/admin/notifications';
        const response = await axiosClient.get(endpoint, { params });
        return response.data;
    },
    markAsRead: async (role, id) => {
        const endpoint = role === 'vendor' ? `/vendors/notifications/${id}/read` : `/admin/notifications/${id}/read`;
        const response = await axiosClient.put(endpoint);
        return response.data;
    },
    deleteNotification: async (role, id) => {
        const endpoint = role === 'vendor' ? `/vendors/notifications/${id}` : `/admin/notifications/${id}`;
        const response = await axiosClient.delete(endpoint);
        return response.data;
    },

    // Admin Only
    sendNotification: async (payload) => {
        // payload: { title, message, target, userId? }
        const response = await axiosClient.post('/admin/notifications', payload);
        return response.data;
    },

    markAllAsRead: async (role) => {
        const endpoint = role === 'vendor' ? '/vendors/notifications/read-all' : '/admin/notifications/read-all';
        const response = await axiosClient.put(endpoint);
        return response.data;
    },

    deleteAllNotifications: async (role) => {
        const endpoint = role === 'vendor' ? '/vendors/notifications' : '/admin/notifications';
        const response = await axiosClient.delete(endpoint);
        return response.data;
    }
};

export default NotificationService;
